// eslint-disable-next-line no-restricted-imports
import { usePlatform } from '@vkontakte/vkui';

/**
 * Платформа темы VKUI. Это признак стилей UI компонентов.
 * Не путать с истинной характеристикой устройства.
 */
export const useVKUIPlatform = usePlatform;
